import { GovMessage } from '@gov-design-system-ce/react';
import { useActiveRezaItem, useRezaSelection } from '@gov-nx/core/hooks';
import { zastupujiciOsobaNazev } from '@gov-nx/module/page';
import { Icon, Space } from '@gov-nx/ui/web';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';

export const RezaInfoBanner = () => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Component);
	const { isRezaSelected } = useRezaSelection();
	const activeRezaItem = useActiveRezaItem();

	if (!isRezaSelected) {
		return null;
	}

	if (!activeRezaItem) {
		return null;
	}

	return (
		<div style={{ marginBottom: 15 }}>
			<GovMessage
				color="primary"
				type="subtle"
				icon={
					<Icon
						type="components"
						name="info-circle-fill"
					/>
				}>
				<div>
					{t('rezaInfoBanner.text')}
					<Space />
					<strong>{zastupujiciOsobaNazev(activeRezaItem)}</strong>.
				</div>
			</GovMessage>
		</div>
	);
};
